import StudentAssignments from "../modules/assignments/student-assignments";
import StudentAttendace from "../modules/attendance/student-attendance";
import FeeStu from "../modules/fees/fee-stu";
import FeeStuVaria from "../modules/fees/fee-stu-varia";
import StudentGallery from "../modules/gallery/student-gallery";

import HomeWorksStu from "../modules/home-works/home-wrks-stu";
//import HomeWorksStu from "../modules/home-works";
import HomeWorksTeach from "../modules/home-works/home-wrks-teach";
import HomePage from "../modules/home/home-page";
import LibraryBooks from "../modules/library-books/library-books";
import Messages from "../modules/messages/messages";
import ChooseProfile from "../modules/profile/choose-profile";
import Logout from "../modules/sign-in/logout";
import SignIn from "../modules/sign-in/sign-in";
import Verify from "../modules/sign-in/verify";
import Test1 from "../modules/test1/test1";
import StudentTimeTable from "../modules/time-table/student-time-table";
import TestComponent from "../testComponent";

export const commonRoutes = [
	{
		path: '/test',
		component: TestComponent,
		private: false,
	},
	{
		path: '/',
		component: SignIn,
		private: false,
		// Disablelogin: true,
	},
	{
		path: '/login',
		component: SignIn,
		private: false,
	},
	{
		path: '/logout',
		component: Logout,
		private: false,
	},
	{
		path: '/verify',
		component: Verify,
		private: false,
	},
	{
		path: '/messages',
		component: Messages,
		private: true,
	},
	{
		path: '/student-home-works',
		component: HomeWorksStu,
		private: true,
	},
	{
		path: '/teacher-home-works',
		component: HomeWorksTeach,
		private: true,
	},
	{
		path: '/student-fee',
		component: FeeStu,
		private: true,
	},
	{
		path: '/student-fee-variation',
		component: FeeStuVaria,
		private: true,
	},
	{
		path: '/student-assignments',
		component: StudentAssignments,
		private: true,
	},
	{
		path: '/student-timetable',
		component: StudentTimeTable,
		private: true,
	},
	{
		path: '/student-gallery',
		component: StudentGallery,
		private: true,
	},
	{
		path: '/choose-profile',
		component: ChooseProfile,
		private: true,
	},
	{
		path: '/home',
		component: HomePage,
		private: true,
	},
	{
		path: '/library-books',
		component: LibraryBooks,
		private: true,
	},
	{
		path: '/student-attendance',
		component: StudentAttendace,
		private: true,
	}
];

